module.exports = __webpack_public_path__ + "img/17.b1f831f2.png";